import pegasus from '../../build/global/js/00-pegasus';

window.contactFormSelector = (visitorType) => {
    return{
        selectedVisitorType: '',
        isLoading: false,
        init(){
            const selectFields = this.$el.getElementsByClassName('Contact__Form-Selector-select');

            pegasus.selectField(selectFields, {
                openOnHover: false,
                itemsToShow: 5,
                classNames: {
                    outerWrapper:   '',
                    selector:       'flex justify-between w-max sm:w-full cursor-pointer text-greyscale-white-06 transition duration-300 bg-greyscale-white-01 border border-greyscale-white-03 text-left pl-4 pr-8 py-2 md:p-4 md:pr-20 lg:pr-40 rounded-[50px] focus:outline-none',
                    selectorOpen:   'rounded-[30px] rounded-b-none border-b-0',
                    selectionList:  'w-full bg-greyscale-white-01 border border-greyscale-white-03 border-t-0 rounded-b-[30px] px-3',
                    listItem:       'text-greyscale-white-06 font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-04 transition duration-300 hover:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });

            this.selectedVisitorType = visitorType;

            this.checkForContent();
        },
        getContactPage(id){
            const elements = ['data-pegasus-contact-page'];
            const href = pegasus.getURL() + '?i-am-a=' + this.selectedVisitorType + '&looking-for=' + id;

            this.isLoading = true;
            pegasus.ajaxContent(href, elements, {}, () => {
                pegasus.scroll(document.querySelectorAll('[data-pegasus-contact-page]')[0]);
                 //reinit cf7 forms
                 if (wpcf7) {
                    const cf7Forms = document.querySelectorAll('.wpcf7 > form');
                    if (cf7Forms.length) cf7Forms.forEach((form) => wpcf7.init(form));
                    if (window.initDragDrop && typeof window.initDragDrop === 'function') window.initDragDrop();
                }
                this.isLoading = false;
            }, true);
        },
        submitForm(){
            window.location.href = pegasus.getURL() + '?looking-for=' + this.$el.value;
        },
        checkForContent(){
            const contactPageContainer = document.getElementsByClassName('Contact_Form-Selector--Contact-page')[0];
            
            if(contactPageContainer.children.length){
                pegasus.scroll(document.querySelectorAll('[data-pegasus-contact-page]')[0]);
            }
        }
    }
}